import {Component, Input} from '@angular/core';
import {MarketplaceContentBlock} from '@webmate-web-core/shared/types/marketplace';

@Component({
    selector: 'wm-marketplace-content',
    templateUrl: './marketplace-content.component.html',
    styleUrls: ['./marketplace-content.component.less']
})
export class MarketplaceContentComponent {

    @Input({required: true}) blocks: MarketplaceContentBlock[] = [];
}
